module.exports = __webpack_public_path__ + "img/yy.2492a01e.png";